<template>
<svg viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5l-8.66,5v10l8.66,5l8.66-5v-10L0.5,782.5z M-0.5,787.5h2v4h4v2h-4v4h-2v-4h-4v-2h4V787.5z"/>
</svg>

</template>